import { render, staticRenderFns } from "./LeadDistribution.vue?vue&type=template&id=280fc61c&scoped=true&"
import script from "./LeadDistribution.vue?vue&type=script&lang=js&"
export * from "./LeadDistribution.vue?vue&type=script&lang=js&"
import style0 from "./LeadDistribution.vue?vue&type=style&index=0&id=280fc61c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280fc61c",
  null
  
)

export default component.exports